import { Avatar, Box, Button, Divider, List, ListItem, Toolbar } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PersonIcon from '@material-ui/icons/Person';
import { completedRoutes } from '../../common/constants';

const SideBar = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = history.location;
  const {
    toggleDrawer, userName, handleLogout, admin, isLogged, handleLogin,
  } = props;

  const navBarLinksMapping = {
    tasks: completedRoutes.userTasks,
    myActivity: completedRoutes.userActivity,
    rules: admin ? completedRoutes.adminRules : completedRoutes.userRules,
    myPlaces: completedRoutes.adminPlaces,
    forCompanies: admin ? completedRoutes.adminForCompanies : completedRoutes.userForCompanies,
    userPayment: completedRoutes.userPayment,
    userPlaces: completedRoutes.userPlaces,
  };


  const geActiveLink = () => {
    switch (pathname) {
      case navBarLinksMapping.tasks:
        return 'tasks';
      case navBarLinksMapping.myActivity:
        return 'myActivity';
      case navBarLinksMapping.forCompanies:
        return 'forCompanies';
      case navBarLinksMapping.rules:
        return 'rules';
      case navBarLinksMapping.userPayment:
        return 'userPayment';
      case navBarLinksMapping.myPlaces:
        return 'myPlaces';
      case navBarLinksMapping.userPlaces:
        return 'userPlaces';
      default:
        return admin ? 'places' : 'tasks';
    }
  };

  return (
    <div
      className="side-bar"
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Toolbar />
      <Box className="user-panel-container">
        {isLogged && (
          <div className="user-info">
            <Avatar className="avatar">
              <PersonIcon />
            </Avatar>
            <div className="log-cnt">
              <span className="log-info">{userName}</span>
              {admin && <span className="admin-info">{t('common.admin')}</span>}
            </div>
          </div>
        )}
        {isLogged ? (
          <Button variant="outlined" className="logout" onClick={handleLogout}>
            <span className="logout-text">{t('common.logout')}</span>
          </Button>
        ) : (
          <Button variant="outlined" className="logout" onClick={handleLogin}>
            <span className="logout-text">{t('common.login')}</span>
          </Button>
        )}
      </Box>
      <List className="nav-bar mobile">
        {!admin ?
          <>
            <ListItem style={{ background: geActiveLink() === 'tasks' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.tasks}
                    className="link">
                {t('navBar.tasks')}
              </Link>
            </ListItem>
            <ListItem style={{ background: geActiveLink() === 'myActivity' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.myActivity}
                    className={`link ${geActiveLink() === 'myActivity' ? 'active' : ''}`}>
                {t('navBar.myActivity')}
              </Link>
            </ListItem>
            <ListItem style={{ background: geActiveLink() === 'userPlaces' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.userPlaces}
                    className={`link ${geActiveLink() === 'userPlaces' ? 'active' : ''}`}>
                {t('navBar.userPlaces')}
              </Link>
            </ListItem>
            <ListItem style={{ background: geActiveLink() === 'userPayment' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.userPayment}
                    className={`link ${geActiveLink() === 'userPayment' ? 'active' : ''}`}>
                <span className="green">{t('navBar.userPayment')}</span>
              </Link>
            </ListItem>
            <Divider />
            <br />
            <ListItem style={{ background: geActiveLink() === 'rules' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.rules}
                    className={`link ${geActiveLink() === 'rules' ? 'active' : ''}`}>
                {t('navBar.rules')}
              </Link>
            </ListItem>
            <ListItem style={{ background: geActiveLink() === 'forCompanies' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.forCompanies}
                    className={`link ${geActiveLink() === 'forCompanies' ? 'active' : ''}`}>
                {t('navBar.forCompanies')}
              </Link>
            </ListItem>
          </>
          :
          <>
            <ListItem style={{ background: geActiveLink() === 'myPlaces' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.myPlaces}
                    className={`link underline ${geActiveLink() === 'myPlaces' ? 'active' : ''}`}>
                {t('navBar.myPlaces')}
              </Link>
            </ListItem>
            <br />
            <Divider />
            <br />
            <ListItem style={{ background: geActiveLink() === 'rules' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.rules}
                    className={`link ${geActiveLink() === 'rules' ? 'active' : ''}`}>
                {t('navBar.rules')}
              </Link>
            </ListItem>
            <ListItem style={{ background: geActiveLink() === 'forCompanies' ? '#f2f2f2' : 'none' }}>
              <Link to={navBarLinksMapping.forCompanies}
                    className={`link ${geActiveLink() === 'forCompanies' ? 'active' : ''}`}>
                {t('navBar.forCompanies')}
              </Link>
            </ListItem>
          </>
        }
      </List>
    </div>
  );
};

export default SideBar;
